/**
 * Eventos de ventana (cross-component) para señales puntuales sin acoplar
 * componentes vía props/context.
 */

/**
 * Se dispara cuando se cierra la modal de onboarding (welcome / personalización).
 * Lo escucha la página de Ajustes para recargar sus datos (intereses, meta,
 * hora de estudio…) que el onboarding pudo haber cambiado.
 */
export const ONBOARDING_CLOSED_EVENT = 'kc:onboarding-closed';

/**
 * Cambio de alcanzabilidad del servidor de la API (detail: { unreachable }).
 * Lo emite services/api/serverReachability cuando varias peticiones seguidas
 * fallan a nivel de red (proveedor caído, DNS, timeout) y cuando el servidor
 * vuelve a responder. Lo escucha el banner global (OfflineBanner).
 */
export const SERVER_REACHABILITY_EVENT = 'kc:server-reachability';
